class FinanceCalculator {
	constructor() {

		this.finance_type = "";
		this.total_cost = 0;
		this.amount = 0;
		this.interest_per = 0;
		this.deposit = 0;
		this.deposit_amount = 300;
		this.repayment_term = 0;
		this.results_elms = {};
		this.init_results();
		this.monthly_cost = 0;
		this.init_events();

	}

	init_events() {

		const self = this;

		self.finance_type = document.getElementById('finance-type').value;
		if(self.finance_type == "9-9-apr"){
			self.interest_per = 9.9;
		} else {
			// Both other options are 0% interest
			self.interest_per = 0;
		}

		const $total_cost = document.getElementById('finance-total-cost');
		const $amount = document.getElementById('finance-amount');
		const $deposit = document.getElementById('depositamount');
		const $finance_repayment_term = Array.from(document.querySelectorAll('[name=financerepaymentterm]'));

		$total_cost.addEventListener('change', (e) => {
			self.total_cost = e.target.value;
			self.amount = e.target.value; 
			$amount.value = self.amount;
			self.calculate();
		});

		$amount.addEventListener('input', (e) => {
			self.amount = parseFloat(e.target.value);
			self.calculate();
		});

		$deposit.addEventListener('input', (e) => {
			let deposit_warning = document.querySelector('.deposit-warning');
			this.deposit_amount = e.target.value;
			if(e.target.value < 300){
				deposit_warning.classList.add('active');
				this.reset_results();
			} else {
				deposit_warning.classList.remove('active');
				this.deposit_amount = parseFloat(e.target.value);
				self.calculate();
			}
		});

		$finance_repayment_term.forEach(($elm) => {
			$elm.addEventListener('change', () => {
				let $selected = $finance_repayment_term.filter(node => node.checked);
				if ($selected) {
					self.repayment_term = parseInt($selected[0].value);
					self.calculate();
				}
			});
		});

	}

	init_results() {
		this.results_elms = {
			monthly: document.querySelectorAll('.finance-results-monthly-cost'),
			months: document.querySelectorAll('.finance-results-months'),
			total_repayable: document.querySelectorAll('.finance-results-total-repayable'),
			install_cost: document.querySelectorAll('.finance-results-install-cost'),
			deposit: document.querySelectorAll('.finance-results-deposit'),
			disclaimer: document.querySelectorAll('.disclaimer'),
		};
	}

	// Interest calculation refer to : https://gist.github.com/maarten00/23400873d51bf2ec4eeb
	pmt(rate, nper, pv, fv = 0, type = 0) {

		if (rate == 0) {
			return -(pv + fv) / nper;
		}

		var pvif = Math.pow(1 + rate, nper);
		var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

		if (type == 1) {
			pmt /= (1 + rate);
		}

		return pmt;
	}

	// Round and fix to 2dp
	to_currency(value) {
		return (Math.round(value * 100) / 100).toFixed(2);
	}

	valid() {
		if(this.repayment_term > 0 && this.amount > 0 && this.deposit_amount >= 300){
			return true;
		} else {
			return false; 
		}
	}

	calculate() {

		// Return out if not valid
		if (!this.valid()) return;

		// Get total amount
		let amount = this.amount;

		// Calculate deposit
		this.deposit = this.to_currency(this.deposit_amount);
		
		// Minus deposit off amount owed
		amount -= this.deposit;

		// Interest free loans cannot exceed 3000 - warn the user - reset the results
		let amount_input = document.querySelector('.amount-input');
		if(amount > 3000 && this.finance_type == 'interest-free-credit'){
			amount_input.classList.add('active');
			this.reset_results();
			return; 
		} else {
			amount_input.classList.remove('active');
		}

		let monthly_cost = 0;

		// Calculate monthly rate
		let rate = this.interest_per/1200; // Divide 100 for %, divide 12 for monthly rate
		
		// Calculate PMT
		monthly_cost = this.pmt(rate, this.repayment_term, amount);

		// Absolute value
		monthly_cost = Math.abs(monthly_cost);
		monthly_cost = this.to_currency(monthly_cost);

		this.total_repayable = this.to_currency(Math.round(monthly_cost * this.repayment_term));
		this.monthly_cost = monthly_cost;

		var $disclaimer = document.getElementById('disclaimer');
		$disclaimer.innerHTML = '<p>The following figures are an estimation. Please contact us for a comprehensive quote.</p>';

		this.show_results();
	}

	show_results() {
		this.results_elms.monthly.forEach(($elm) => {
			$elm.innerHTML = `£${this.monthly_cost}`;
		});

		this.results_elms.months.forEach(($elm) => {
			$elm.innerHTML = `${this.repayment_term}`;
		});

		this.results_elms.total_repayable.forEach(($elm) => {
			$elm.innerHTML = `£${this.total_repayable}`;
		});

		this.results_elms.install_cost.forEach(($elm) => {
			$elm.innerHTML = `£${this.amount}`;
		});

		this.results_elms.deposit.forEach(($elm) => {
			$elm.innerHTML = `£${this.deposit}`;
		});
	}

	reset_results() {
		this.results_elms.monthly.forEach(($elm) => {
			$elm.innerHTML = `£0`;
		});

		this.results_elms.months.forEach(($elm) => {
			$elm.innerHTML = `0`;
		});

		this.results_elms.total_repayable.forEach(($elm) => {
			$elm.innerHTML = `£0`;
		});

		this.results_elms.install_cost.forEach(($elm) => {
			$elm.innerHTML = `0`;
		});

		this.results_elms.deposit.forEach(($elm) => {
			$elm.innerHTML = `0`;
		});

		this.results_elms.disclaimer.forEach(($elm) => {
			$elm.innerHTML = ``;
		});
	}
}

if(document.getElementById('finance-total-cost')){
	new FinanceCalculator();	
}

